<template>
    <b-badge
        :variant="color"
        :pill="pill"
    >
        <slot />
    </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    components: { BBadge },
    props: {
        pill: { type: Boolean, default: false },
        color: { type: String, default: 'primary' },
    }
}
</script>